import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/abreviatura-de-carrera';

/**
 * GET Abreviaturas de carreras
 * @returns {Promise<object[]>}
 */
export const getAbreviaturasDeCarreras = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Abreviatura de carrera
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getAbreviaturaDeCarrera = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Abreviatura de carrera
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAbreviaturaDeCarrera = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Abreviatura de carrera
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAbreviaturaDeCarrera = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Abreviatura de carrera
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteAbreviaturaDeCarrera = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
